import React from 'react';
import { Container, Row } from 'react-bootstrap';

function Header() {
  return (
    <Container
      style={{
        backgroundColor: '#1313b7',
        opacity: '1',
        backgroundImage: 'radial-gradient(#5860ff 1.2000000000000002px, transparent 1.2000000000000002px), radial-gradient(#5860ff 1.2000000000000002px, #1313b7 1.2000000000000002px)',
        maxWidth: 'calc(90%)',
        backgroundSize: '48px 48px',
        backgroundPosition: '0 0, 24px 24px',
        marginBottom: '50px',
        marginTop: '50px',
        borderRadius: '10px',
      }}
    >
      <Row style={{ padding: '15px 0' }}>
        <div
          style={{
            margin: '0 auto', width: '350px',
            backgroundSize: 'contain', backgroundImage: 'url("/img/midwesternglow.png")'
            ,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            height: '150px',

          }}
        />
      </Row>
    </Container >
  );
}

export default Header;


